import { csConstants } from "../../constants";

export function cs(state={}, action) {
  const {
    // cs reports page
    guidance,
    reports,
    reportId,
    // assessment report page
    report,
    assessmentReportTemplates,
    assessmentReportPreview,
  } = state;
  switch (action.type) {
    case csConstants.LIST_GUIDANCE_REQUEST:
      return { isListingGuidance: true };
    case csConstants.LIST_GUIDANCE_SUCCESS:
      return { guidance: action.payload.data };
    case csConstants.LIST_GUIDANCE_FAILURE:
      return {};
    case csConstants.UPDATE_GUIDANCE_REQUEST:
      return { isUpdatingGuidance: true };
    case csConstants.UPDATE_GUIDANCE_SUCCESS:
      return { guidance: action.payload.data };
    case csConstants.UPDATE_GUIDANCE_FAILURE:
      return { guidance };
    case csConstants.LIST_REPORTS_REQUEST:
      return { isListingReports: true };
    case csConstants.LIST_REPORTS_SUCCESS:
      return { reports: action.payload.data };
    case csConstants.LIST_REPORTS_FAILURE:
      return { reports };
    case csConstants.VALIDATE_REPORT_REQUEST:
      return {
        reports,
        isValidating: true,
      };
    case csConstants.VALIDATE_REPORT_SUCCESS:
      return {
        reports,
        reportId: action.payload.data.id,
        isValidating: true,
      };
    case csConstants.VALIDATE_REPORT_FAILURE:
      return { reports };
    case csConstants.VALIDATION_STATUS_SUCCESS:
      switch (action.payload.data.status) {
        case "valid":
          return {
            reports,
            reportId,
            isValid: true,
          };
        case "invalid":
          return {
            reports,
            reportId,
            isInvalid: true,
          };
        default:  // "validating"
          return state;
      }
    case csConstants.VALIDATION_STATUS_FAILURE:
      return {
        reports,
        reportId,
      };
    case csConstants.PROCESS_REPORT_REQUEST:
      return {
        reports,
        reportId,
      };
    case csConstants.PROCESS_REPORT_SUCCESS:
      return {
        reports,
        reportId,
        isProcessing: true,
      };
    case csConstants.PROCESS_REPORT_FAILURE:
      return {
        reports,
        reportId,
      };
    case csConstants.RETRIEVE_REPORT_REQUEST:
      return {
        isRetrieving: true,
      };
    case csConstants.RETRIEVE_REPORT_SUCCESS:
      return {
        report: action.payload.data,
        assessmentReportTemplates,
      };
    case csConstants.RETRIEVE_REPORT_FAILURE:
      return {
        assessmentReportTemplates,
      };
    case csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_REQUEST:
      return {
        isListingAssessmentReportTemplates: true,
      };
    case csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_SUCCESS:
      return {
        report,
        assessmentReportTemplates: action.payload.data,
      };
    case csConstants.LIST_ASSESSMENT_REPORT_TEMPLATES_FAILURE:
      return {
        report,
      };
    case csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_REQUEST:
      return {
        report,
        assessmentReportTemplates,
        isCreatingAssessmentReportPreview: true,
      };
    case csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_SUCCESS:
      return {
        report,
        assessmentReportTemplates,
        assessmentReportPreview: action.payload.data.content,
      };
    case csConstants.CREATE_ASSESSMENT_REPORT_PREVIEW_FAILURE:
      return {
        report,
        assessmentReportTemplates,
      };
    default:
      return state;
  }
}